define('../app/fukit/view/block/basic.table.view',['require','exports','module','uikit/uikit','underscore','../../behavior/table.sort.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit             = require('uikit/uikit'),
      _                 = require('underscore'),
      TableSortBehavior = require('../../behavior/table.sort.behavior');


  var TableBlockView = UIKit.Table.extend({

    behaviors: {
      TableSortBehavior: {
        behaviorClass: TableSortBehavior
      }
    },

    options: _.extend({}, UIKit.Table.prototype.options, {
      selectable: true
    })

  });

  module.exports = TableBlockView;
});

